import React from 'react';
import { benefitStrip } from '../data/product';
export function BenefitStrip() {
  return <section aria-label="Key benefits" className="border-b border-white/10 bg-ink-850" data-id="element-74" data-mp="30fluvjaszxop">
      <ul className="mx-auto grid max-w-[1400px] grid-cols-2 gap-px bg-white/10 sm:grid-cols-3 lg:grid-cols-6" data-id="element-75" data-mp="2mfksu0isyk7n">
        {benefitStrip.map(benefit => {
        const isLifetime = /lifetime/i.test(benefit);
        return <li key={benefit} className={`px-3 py-4 text-center font-display text-base font-bold uppercase leading-tight tracking-wide sm:text-lg lg:py-5 ${isLifetime ? 'gold-plate font-extrabold text-ink-950' : 'bg-ink-850 text-offwhite'}`} data-id="element-76" data-mp="3f51kgvyllx2t">
              {benefit}
            </li>;
      })}
      </ul>
    </section>;
}